module.exports = __webpack_public_path__ + "static/media/lang-cn.66f9166f.svg";